import { createModule } from '../createModule';
import { IFileWrapper, ICRUDResponse } from '@/models';
import { client } from '..';
import { NOTIFICATION_TIMEOUT } from '@/const';

export const file = createModule('file', {
  actions: {
    createEntity({ }, entity: Omit<IFileWrapper, 'id'>) {
      const data = new FormData();
      if (!entity.file) return;
      data.append('file', entity.file);
      data.append('name', entity.file.name);
      return client.post('file', data);
    },
    async getEntity({ commit }, id) {
      const { data: { data } } = await client
        .get<ICRUDResponse<IFileWrapper>>(`file/${id}`)
      return data
    },
    async uploadFiles({ dispatch, commit }, filesList: FileList) {
      const files = Array.from(filesList);
      const promises = files.map(async (file) => {
        const notificationId = new Date().valueOf();
        commit(
          'notification/createPersistentNotification',
          {
            type: 'info',
            text: `Файл «${file.name}» загружается`,
            id: notificationId,
          },
          { root: true },
        );
        try {
          const uploadedFile = await dispatch('createEntity', { file });
          commit(
            'notification/updatePersistentNotification',
            {
              type: 'success',
              id: notificationId,
              text: `Файл «${file.name}»  загружен`,
              isPending: false,
            },
            { root: true },
          );
          setTimeout(
            () =>
              commit('notification/closeNotification', notificationId, {
                root: true,
              }),
            NOTIFICATION_TIMEOUT,
          );
          return uploadedFile;
        } catch (e) {
          commit('notification/updatePersistentNotification', {
            type: 'error',
            id: notificationId,
            text: `Файл «${file.name}» не был загружен из-за ошибки`,
          });
          return undefined;
        }
      });
      return await Promise.all(promises).then((files) =>
        files.filter(Boolean).map(({ data }) => data),
      );
    },
  },
});
